module.exports = __webpack_public_path__ + "static/media/Barlow-ExtraBold.b799e301.ttf";